import CardContentLoadingComponent from 'crm-cards-sdk/components/skeletons/CardContentLoadingComponent';
import { useAssociatedObjectsCardRedesignContext } from '../../context/AssociatedObjectsCardRedesignContext';
import { CardEmptyState } from '../../extensions/constants/BehaviorTypes';
import { useBehavior } from '../../extensions/hooks/useBehavior';
import AssociationsActionBar from './actionBar/AssociationsActionBar';
import AssociationChiclet from './chiclet/AssociationChiclet';
import { useCardRenderMarkers } from 'crm-cards-sdk/hooks/useCardRenderMarkers';
import CardFooter from './CardFooter';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function CardContent() {
  const {
    cardId,
    fromObjectId,
    fromObjectTypeId,
    hasScope,
    isUngated,
    isLoading,
    objectTypeDefinition,
    propertyNames,
    results,
    toObjectTypeId
  } = useAssociatedObjectsCardRedesignContext();
  const {
    SuccessMarker
  } = useCardRenderMarkers();
  const CardEmptyStateComponent = useBehavior(CardEmptyState, toObjectTypeId, hasScope, isUngated);
  let content;
  if (isLoading) {
    content = /*#__PURE__*/_jsx(CardContentLoadingComponent, {});
  } else if (!results || results.length === 0) {
    var _objectTypeDefinition;
    content = /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(CardEmptyStateComponent, {
        cardId: cardId,
        fromObjectTypeId: toObjectTypeId,
        hasScope: hasScope,
        isUngated: isUngated,
        numberOfProperties: propertyNames.length,
        toObjectPluralForm: (_objectTypeDefinition = objectTypeDefinition === null || objectTypeDefinition === void 0 ? void 0 : objectTypeDefinition.pluralForm) !== null && _objectTypeDefinition !== void 0 ? _objectTypeDefinition : ''
      }), /*#__PURE__*/_jsx(SuccessMarker, {})]
    });
  } else {
    content = /*#__PURE__*/_jsxs(_Fragment, {
      children: [results.map(association => /*#__PURE__*/_jsx(AssociationChiclet, {
        association: association
      }, association.objectId)), /*#__PURE__*/_jsx(SuccessMarker, {})]
    });
  }
  return /*#__PURE__*/_jsxs("div", {
    "data-test-id": `associated-objects-card-content-${toObjectTypeId}`,
    children: [/*#__PURE__*/_jsx(AssociationsActionBar, {}), /*#__PURE__*/_jsx(View, {
      marginBlockStart: "300",
      children: content
    }), /*#__PURE__*/_jsx(CardFooter, {
      fromObjectId: fromObjectId,
      fromObjectTypeId: fromObjectTypeId,
      hasScope: hasScope,
      isUngated: isUngated,
      toObjectTypeId: toObjectTypeId
    })]
  });
}
export default CardContent;